import { render } from "./CartDisplaySmall.vue?vue&type=template&id=1f45f3e9&ts=true"
import script from "./CartDisplaySmall.vue?vue&type=script&lang=ts"
export * from "./CartDisplaySmall.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__